import React from 'react';
import Button from 'components/Button';
import { externalLinkPattern } from 'shared/helpers/patterns';
import { detectAndTrackCatalogueEvent } from 'utils/analytics';
// import { amplitudeEvents, pagesTitles, trackEvent } from 'utils/amplitude';
import { useAuth0 } from '@auth0/auth0-react';

const RedirectAction = ({
  callToAction: {
    style,
    buttonText,
    id,
    action: { url, openInANewTab },
  },
  prevAction,
  linkStyle,
  buttonStyle,
  extraStyle,
  isTextWithOrPrefix,
  userIsnotAuthenticated = false,
  title,
  pageTitle,
}) => {
  const { user } = useAuth0();
  const redirectUrl = userIsnotAuthenticated
    ? userIsnotAuthenticated === 'unverified'
      ? '/auth/unverified'
      : '/auth/login'
    : url;

  const handleClick = () => {
    const auctionName = title || pageTitle;
    detectAndTrackCatalogueEvent(buttonText, auctionName);
  };

  return openInANewTab || externalLinkPattern.test(url) ? (
    <a
      href={url}
      className={`${
        style?.includes('Button')
          ? `${buttonStyle} ${extraStyle}`
          : `${linkStyle} ${extraStyle}`
      } button`}
      target={openInANewTab ? '_blank' : '_self'}
      rel="noreferrer"
      onClick={handleClick}
    >
      {prevAction?.includes('Button') && style === 'Text'
        ? `${isTextWithOrPrefix ? 'Or, ' : ''}${buttonText}`
        : buttonText}
    </a>
  ) : (
    <Button
      type={
        style?.includes('Button')
          ? `${buttonStyle} ${extraStyle}`
          : `${linkStyle} ${extraStyle}`
      }
      key={`heroSectionButton_${id}`}
      linkAsButton={true}
      path={redirectUrl}
      handleClick={handleClick}
    >
      {prevAction?.includes('Button') && style === 'Text'
        ? `${isTextWithOrPrefix ? 'Or, ' : ''}${buttonText}`
        : buttonText}
    </Button>
  );
};

export default RedirectAction;
